import Record from '../Record'

export default class Terminal extends Record {

	constructor (data) {
		super(data)

		data.remote_settings = new Record(data.remote_settings || {})

		return this._proxy
	}

	static async fetch (machine_id = null) {
		if (machine_id == null) {
			throw new Error('Terminal ID must be specified')
		}

		let data = await Anvil.REST.get(`/c_order/terminal/${machine_id}`)
		return new Terminal(data)
	}

	static async delete (machine_id) {
		await Anvil.REST.delete(`/c_order/terminal/${machine_id}`)
	}

	async commit () {
		if (this._data.machine_id == null) {
			// Insert
			throw new Error('Terminált létrehozni nem lehet')
		} else {

			const data = { ...this._data }
			const debits = [ ...data.recurring_debits, ...data.one_time_debits ]
			delete data.debits

			// Update head
			await Anvil.REST.put(`/c_order/terminal/${this._data.machine_id}`, this._data)

			// Update debits
			await Anvil.REST.put(`/c_order/debit/push/${this._data.company_id}/terminal/${this._data.machine_id}`, debits)
		}
	}

	static async fetch_ntak_stats () {
		const res = await Anvil.REST.get(`/c_order/fetch_ntak_stats`)
		console.log(res)
	}
}
